import Opener from './opener'

import Fuse from 'fuse.js'

export default {
  extends: Opener,
  fuse: {
    shouldSort: false,
    threshold: 0.1,
    location: 0,
    distance: 1000,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: ['name', 'keywords'],
  },

  props: {
    query: String,
  },

  watch: {
    query(nval) {
      this.search()
      this.opened = { index: Infinity, element: null }
    }
  },

  methods: {
    search() {
      let query = this.query.trim()

      if (!query) {
        this.list = this.items
        return
      }

      let fuse = new Fuse(this.items, this.$options.fuse)
      this.list = fuse.search(query)
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/shared/components/alphabet/searchable.js